import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
const Dispute = () => {
  const navigate = useNavigate();
  const TableData = [
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Panding",
      action: "Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Accept",
      action: "In Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "unread",
      status: "Reject",
      action: "Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Panding",
      action: "Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Accept",
      action: "In Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "unread",
      status: "Reject",
      action: "Active",
    },
  ];

  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <Button className="header-button" variant="text">
                <p className="page-header-button-text">Download</p>
              </Button>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => navigate("/tutor-panel/dispute/create")}
              >
                <p className="page-header-button-text">Create</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">Search by booking</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by booking"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={3} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">Admin status</p>
                <select className="header-dropdown">
                  <option value="All">All</option>
                  <option value="Read">Read</option>
                  <option value="Unread">Unread</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={3} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">dispute Status</p>
                <select className="header-dropdown">
                  <option value="All">All</option>
                  <option value="Panding">Panding</option>
                  <option value="Resolved">Resolved</option>
                  <option value="Terminated">Terminated</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="disput-table-id-heading">ID</th>
                <th className="disput-table-booking-heading">Booking</th>
                <th className="disput-table-create-date-heading">
                  Create date
                </th>
                <th className="disput-table-description-heading">
                  Discription
                </th>
                <th className="disput-table-admin-status-heading">
                  Admin Status
                </th>
                <th className="disput-table-dispute-status-heading">
                  dispute Status
                </th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableIndex + 1}</td>
                    <td className="table-data">posuere nulla pharetra</td>
                    <td className="table-data">JAN 4, 2022</td>
                    <td className="table-data">Lorem ipsum dolor sit a...</td>
                    <td className="table-data">
                      <div
                        className="table-data--button"
                        style={{
                          backgroundColor:
                            tableValue.adminStatus === "Read"
                              ? "#FAD7FF"
                              : "#E2E2E2",
                        }}
                      >
                        <p
                          className="table-data--button-title"
                          style={{
                            color:
                              tableValue.adminStatus === "Read"
                                ? "#5E006A"
                                : "#4F4F4F",
                          }}
                        >
                          {tableValue.adminStatus}
                        </p>
                      </div>
                    </td>
                    <td className="table-data">
                      <div
                        className="table-data--button"
                        style={{
                          backgroundColor:
                            tableValue.status === "Panding"
                              ? "#FFD1B0"
                              : tableValue.status === "Reject"
                              ? "#FFB0B0"
                              : "#D2FFEB",
                        }}
                      >
                        <p
                          className="table-data--button-title"
                          style={{
                            color:
                              tableValue.status === "Panding"
                                ? "#B84D00"
                                : tableValue.status === "Reject"
                                ? "#B80000"
                                : "#098B51",
                          }}
                        >
                          {tableValue.status}
                        </p>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default Dispute;
